import request from '@/utils/request'

// 去除对象中的空value属性
function filterParams (obj) {
	let newObj = {}
	for (let val in obj) {
		if (obj[val] !== '') newObj[val] = obj[val]
	}
	return newObj
}

// 增增票资质审核 --------------------------------------------------
export function searchApplyCertification (val) {
	return request({
		url: '/api/finance/admin/store/certification/page',
		method: 'post',
		data: val.certificationVo,
		params: {
			page: val.page,
			size: val.size
		}
	})
}

export function certificationAudit (val) {
	return request({
		url: `/api/finance/admin/store/certification/audit-${val.action}-${val.storeCertId}`,
		method: 'post'
	})
}
// 发票申请记录 --------------------------------------------------
export function searchInvoice (val) {
	return request({
		url: '/api/finance/admin/fapiao/page',
		method: 'post',
		data: val.vo,
		params: {
			page: val.page,
			size: val.size,
			descField: val.descField
		}
	})
}
// 开票状态查询-------------------------------------------------------------------------------
export function fapiaoQuery (val) {
	return request({
		url: '/api/finance/admin/fapiao/query/inv_K_status',
		method: 'post',
		data: val
	})
}
// A- fin_fapiao-----------------------------------------------------------------------------------------
// addExpress
export function fapiaoAddExpress (val) {
	return request({
		url: `/api/finance/admin/fapiao/addExpress_${val.fapiaoId}`,
		method: 'post',
		data: val.data
	})
}

// K票
export function fapiaoInvoice (val) {
	return request({
		url: `/api/finance/admin/fapiao/invoice/${val.fapiaoId}`,
		method: 'post',
		params: {
			taxRateId: val.taxRateId
		}
	})
}

// A- tax_rate--------------------------------------------------------------------------------------------------------------
// add
export function taxRateAdd (val) {
	return request({
		url: '/api/finance/admin/taxRate/add',
		method: 'post',
		data: val
	})
}
// page
export function taxRatePage (val) {
	return request({
		url: '/api/finance/admin/taxRate/page',
		method: 'post',
		data: filterParams(val.data),
		params: val.params
	})
}
// listAll
export function taxRateListAll () {
	return request({
		url: '/api/finance/admin/taxRate/listAll',
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// deleteById
export function taxRateDelete (id) {
	return request({
		url: `/api/finance/admin/taxRate/delete/${id}`,
		method: 'delete',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// getDefaultTaxRate
export function taxRateGetDefaultTaxRate () {
	return request({
		url: '/api/finance/admin/taxRate/getDefaultTaxRate',
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// setDefaultTaxRate
export function taxRateSetDefaultTaxRate (id) {
	return request({
		url: `/api/finance/admin/taxRate/setDefaultTaxRate_${id}`,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

// A- tax_rate_type-------------------------------------------------------------------------------------------
// add
export function taxRateTypeAdd (val) {
	return request({
		url: '/api/finance/admin/taxRate/type/add',
		method: 'post',
		data: val
	})
}
// listAll
export function taxRateTypeListAll () {
	return request({
		url: '/api/finance/admin/taxRate/type/listAll',
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// deleteById
export function taxRateTypeDelete (id) {
	return request({
		url: `/api/finance/admin/taxRate/type/delete/${id}`,
		method: 'delete',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
export function getByOmsOrderNo (val) {
	return request({
		url: '/api/finance/admin/fapiao/getByOmsOrderNo/' + val,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
